import { signUp } from "@services/auth";
import { useMutation } from "@tanstack/react-query";

export const useSignUp = (options: any = {}) => {
  return useMutation<any, any, any>({
    mutationFn: signUp,
    ...options,
  });
};
